export default function InputValidation(inputs) {
  const errors = inputs.map((val) => {
    if (!val || typeof val !== "string") return "Input is required";

    const match = val.match(/^(\d+(?:\.\d+)?)([A-Za-z]{0,2})$/);

    if (!match) return "Input must start with a positive number and have 1–2 valid letters (optional)";

    const number = parseFloat(match[1]);
    const letters = match[2];

    if (isNaN(number) || number <= 0) {
      return "Number must be greater than 0";
    }

    if (letters.length > 0) {
      // Must be either A-Z or k/m/b/t
      const validLetterRegex = /^[A-Z]{1,2}$|^[kmbt]{1,2}$/;
      if (!validLetterRegex.test(letters)) {
        return "Letters must be A-Z or k, m, b, t";
      }
    }

    return ""; // No error
  });

  const hasErrors = errors.some((e) => e !== "");
  return hasErrors ? errors : true;
}
